const React = window.React;
import PropTypes from 'prop-types';

import Attempt from './attempt';
import KeyBoard from './keyboard';
import { TURBO_STREAM_TYPE, renderTurboStream } from '../../utils/turbo_stream';

const KEYBOARDS = {
  azerty: [
    ['a', 'z', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
    ['q', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'm'],
    ['w', 'x', 'c', 'v', 'b', 'n'],
  ],
  qwerty: [
    ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
    ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
    ['z', 'x', 'c', 'v', 'b', 'n', 'm'],
  ],
  qwertz: [
    ['q', 'w', 'e', 'r', 't', 'z', 'u', 'i', 'o', 'p'],
    ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
    ['y', 'x', 'c', 'v', 'b', 'n', 'm'],
  ]
}
class Wordle extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      attempts: this.attemptsArray(),
      results: this.resultsArray(),
      animateIndex: props.attempts.length - 1,
      currentAttemptIndex: this.props.state === 'retry' ? props.attempts.length : props.attempts.length - 1,
      currentLetterIndex: 0,
      currentAttemptClass: new Set(['active']),
      loading: false,
      letters: props.letters
    };

    this.handleKeyBinding = this.handleKeyBinding.bind(this);
  }

  componentDidMount = () => {
    const { readOnly } = this.props;
    if (!readOnly) document.addEventListener('keydown', this.handleKeyBinding);
  }

  componentWillUnmount = () => {
    const { readOnly } = this.props;
    if (!readOnly) document.removeEventListener('keydown', this.handleKeyBinding);
  }

  handleKeyBinding = event => {
    if (document.querySelector('.js-sign-in-modal')) return;

    if (this.isLetter(event)) this.addLetter(this.getLetter(event));
    if (this.isBackspace(event)) this.removeLetter();
    if (this.isEnter(event)) this.submitAttempt();
  }

  attemptsArray() {
    const { attempts, maxAttempts, wordLength } = this.props;
    return attempts.concat(Array.from({ length: maxAttempts - attempts.length }, () => Array.from({ length: wordLength }, () => '')));
  }

  resultsArray() {
    const { results, maxAttempts, wordLength } = this.props;
    return results.concat(Array.from({ length: maxAttempts - results.length }, () => Array.from({ length: wordLength }, () => '')));
  }

  placeholder() {
    const { wordLength } = this.props;
    const { attempts, results } = this.state;
    const placeholder = Array.from({ length: wordLength }, () => '')

    results.map((result, attemptIndex) => {
      result.map((value, letterIndex) => {
        if (placeholder[letterIndex] === '' && value === 'R') {
          const letter = attempts[attemptIndex][letterIndex];
          placeholder[letterIndex] = letter;
        }
      })
    });

    return placeholder;
  }

  isLetter(event) {
    const charCode = event.keyCode;
    return (charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123);
  }

  isBackspace(event) {
    const charCode = event.keyCode;
    return charCode == 8;
  }

  isEnter(event) {
    const charCode = event.keyCode;
    return charCode == 13;
  }

  getLetter(event) {
    if (event.type === 'click') {
      return event.target.innerText.toLowerCase();
    } else {
      const charCode = event.keyCode;
      return String.fromCharCode(charCode).toLowerCase();
    }
  }

  getAttempt(index = null) {
    const { attempts, currentAttemptIndex } = this.state;
    return attempts[index !== null ? index : currentAttemptIndex];
  }

  getAttemptWord(index = null) {
    const attempt = this.getAttempt(index);
    return attempt ? attempt.join('').toLowerCase() : null;
  }

  isWritable() {
    const currentAttempt = this.getAttemptWord();

    if (currentAttempt === null) return false;

    return currentAttempt.length < this.props.wordLength;
  }

  isCleanable() {
    const currentAttempt = this.getAttemptWord();

    if (currentAttempt === null) return false;

    return currentAttempt.length;
  }

  addLetter(letter) {
    if (!this.isWritable() || this.isLoading()) return;

    this.setState(prevState => {
      prevState.attempts[prevState.currentAttemptIndex][prevState.currentLetterIndex] = letter;
      prevState.currentLetterIndex++;
      return prevState;
    });
  }

  removeLetter() {
    if (!this.isCleanable() || this.isLoading()) return;

    this.setState(prevState => {
      prevState.currentLetterIndex--;
      prevState.attempts[prevState.currentAttemptIndex][prevState.currentLetterIndex] = "";
      return prevState;
    });
  }

  triggerWarning(msg = "") {
    if (msg) FLASH.warning(msg);
    this.setState(prevState => {
      prevState.currentAttemptClass.add('animate-shake');
      return prevState;
    }, () => {
      setTimeout(() => {
        this.setState(prevState => {
          prevState.currentAttemptClass.delete('animate-shake');
          return prevState;
        });
      }, 400);
    });
  }

  isLoading() {
    const { loading } = this.state;
    return loading;
  }

  submitAttempt() {
    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    if (this.isWritable()) {
      this.triggerWarning(`Veuillez entrer un mot de ${this.props.wordLength} lettres`);
    } else if(!this.isLoading()) {
      this.setState({ loading: true });

      fetch(this.props.endpoint, {
        method: 'PUT',
        body: JSON.stringify({
          value: this.getAttemptWord()
        }),
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': token
        },
        credentials: 'same-origin'
      }).then(response => response.json())
        .then(data => {
          if (Object.keys(data).length === 0) {
            this.setState({ loading: false }, () => {
              this.triggerWarning(`Ce mot n'est pas valide`);
            });
            return;
          }

          this.setState(prevState => {
            prevState.results[prevState.currentAttemptIndex] = data.result;
            return prevState;
          }, () => {
            setTimeout(() => {
              if (data.state === 'retry') {
                this.setState(prevState => {
                  data.result.map((result, index) => {
                    const letter = prevState.attempts[prevState.currentAttemptIndex][index];
                    if (prevState.letters[letter] !== 'R') prevState.letters[letter] = result;
                  });
                  prevState.currentAttemptIndex++;
                  prevState.currentLetterIndex = 0;
                  prevState.loading = false;
                  return prevState;
                });
              } else { // win or lost
                fetch(this.props.endpoint, {
                  headers: {
                    'Accept': TURBO_STREAM_TYPE,
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-Token': token
                  },
                  credentials: 'same-origin'
                }).then(renderTurboStream);
              }
            }, 1300);
          });
        });
    }
  }

  generateEmptyArray = (attempts, letters) => Array.from({ length: attempts }, () => Array.from({ length: letters }, () => ''));

  getAttemptClass() {
    const grid = [
      '',
      'grid-cols-1',
      'grid-cols-2',
      'grid-cols-3',
      'grid-cols-4',
      'grid-cols-5',
      'grid-cols-6',
      'grid-cols-7',
      'grid-cols-8',
      'grid-cols-9',
      'grid-cols-10'
    ];
    const { wordLength } = this.props;
    return grid[wordLength];
  }

  getResult = (index = null) => {
    const { results, currentAttemptIndex } = this.state;
    return results[index !== null ? index : currentAttemptIndex-1];
  }

  render() {
    const { attempts, animateIndex, currentAttemptIndex, currentLetterIndex, currentAttemptClass, letters } = this.state;
    const { readOnly, keyboard } = this.props;

    return (
      <div className="flex flex-col items-stretch h-full overflow-hidden">
        <div className="w-full flex items-center flex-1">
          <div className={`wordle-grid grid gap-2 grid-cols-1 mx-auto`}>
            {
              attempts.map((attempt, attemptIndex) => {
                const result = this.getResult(attemptIndex);
                return (
                  <Attempt
                    key={`attempt-${attemptIndex}`}
                    attemptClass={this.getAttemptClass()}
                    currentAttemptClass={currentAttemptClass}
                    result={result}
                    attempt={attempt}
                    attemptIndex={attemptIndex}
                    currentAttemptIndex={currentAttemptIndex}
                    currentLetterIndex={currentLetterIndex}
                    animateIndex={animateIndex}
                    readOnly={readOnly}
                    placeholder={this.placeholder()}
                  />
                );
              })
            }
          </div>
        </div>
        {
          !readOnly && (
            <div className="w-full flex items-end">
              <div className="wordle-keyboard mx-auto my-8 disable-dbl-tap-zoom">
                <div className="flex w-full justify-center">
                  { KEYBOARDS[keyboard][0].map(key => <KeyBoard key={`letter-${key}`} letters={letters} onClick={() => this.addLetter(key)}>{key}</KeyBoard>) }
                </div>
                <div className="flex w-full justify-center">
                  { keyboard !== "azerty" && (<KeyBoard size="w-1/2" />) }
                  { KEYBOARDS[keyboard][1].map(key => <KeyBoard key={`letter-${key}`} letters={letters} onClick={() => this.addLetter(key)}>{key}</KeyBoard>) }
                  { keyboard !== "azerty" && (<KeyBoard size="w-1/2" />) }
                </div>
                <div className="flex w-full">
                  <div className="flex flex-1 justify-center">
                    { keyboard === "azerty" && (<KeyBoard size="w-1/2" />) }
                    { KEYBOARDS[keyboard][2].map(key => <KeyBoard key={`letter-${key}`} letters={letters} onClick={() => this.addLetter(key)}>{key}</KeyBoard>) }
                    <KeyBoard onClick={() => this.removeLetter()}>
                      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" style={{ width: "54%" }}>
                        <path fill="#000" d="M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7.07L2.4 12l4.66-7H22v14zm-11.59-2L14 13.41 17.59 17 19 15.59 15.41 12 19 8.41 17.59 7 14 10.59 10.41 7 9 8.41 12.59 12 9 15.59z"></path>
                      </svg>
                    </KeyBoard>
                    <KeyBoard onClick={() => this.submitAttempt()} autoHeight={false} size="" style={{ width: "200%" }} defaultClass="h-full bg-white text-lg leading-none font-semibold uppercase">
                      <i className="fas fa-check inline lg:hidden"></i>
                      <span className="hidden lg:inline">Valider</span>
                    </KeyBoard>
                    { keyboard === "azerty" && (<KeyBoard size="w-1/2" />) }
                  </div>
                </div>
              </div>
            </div>
          )
        }
      </div>
    );
  }
}

Wordle.propTypes = {
  state: PropTypes.string,
  endpoint: PropTypes.string,
  wordLength: PropTypes.number,
  maxAttempts: PropTypes.number,
  attempts: PropTypes.array,
  results: PropTypes.array,
  letters: PropTypes.object,
  readOnly: PropTypes.bool,
  keyboard: PropTypes.string
};

Wordle.defaultProps = {
  attempts: [],
  results: [],
  letters: {},
  readOnly: false,
  keyboard: "azerty"
};

export default Wordle;
